import axiosInstance from "../axiosInterceptor";

export async function createQuestionAssignmentHelp(body) {
  const { categoryId, questionPDF, referencePDF } = body;
  const formdata = new FormData();
  formdata.append("categoryId", categoryId);
  formdata.append("subCategoryId", body.subCategory);
  formdata.append("question", body.question);
  formdata.append("subjectId", body.subject);
  if (body.haveReferenceFile === "Yes") {
    formdata.append("isReference", true);
  } else {
    formdata.append("isReference", false);
  }

  if (questionPDF) {
    questionPDF.forEach((file, index) => {
      formdata.append(`questionPDF`, file);
    });
  }
  if (referencePDF) {
    referencePDF.forEach((file, index) => {
      formdata.append(`referencePDF`, file);
    });
  }
  // return
  const response = await axiosInstance.post(
    `/student/assignmentHelp/createQuestion`,
    formdata,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  const data = response?.data;
  return data;
}
